<template>
  <div>
    <b-row align="left">
      <b-col md="6" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Application</font>
        </p>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="2" class="pr-0">
        <b-button
          block
          @click="tab_menu = 'userapp'"
          :variant="tab_menu === 'userapp' ? '': 'light'"
          :class="tab_menu === 'userapp' ? 'bg-primary text-white':'bg-white text-primary'"
          size="lg"
        >Userapp</b-button>
      </b-col>
      <b-col md="2" class="pl-0">
        <b-button
          block
          @click="tab_menu = 'paxelmarket'"
          :variant="tab_menu === 'paxelmarket' ? '': 'light'"
          :class="tab_menu === 'paxelmarket' ? 'bg-primary text-white':'bg-white text-primary'"
          class="border-light"
          size="lg"
        >PaxelMarket</b-button>
      </b-col>
    </b-row>
    <b-row>
      <transition name="fade" mode="out-in">
        <b-col v-if="tab_menu === 'userapp'" class="mt-4" md="12" :key="1">
          <userapp></userapp>
        </b-col>
        <b-col v-else md="12" class="mt-4" :key="2">
          <paxel-market></paxel-market>
        </b-col>
      </transition>
    </b-row>
  </div>
</template>

<script>
const PaxelMarket = () => import("./app/PaxelMarket");
const Userapp = () => import("./app/Userapp");

export default {
  components: {
    PaxelMarket: PaxelMarket,
    Userapp: Userapp,
  },
  data() {
    return {
      tab_menu: "userapp",
    }
  },
};
</script>
